const en = {
  "common.cancel": "Cancel",
  "common.close": "Close",
  "common.on": "On",
  "common.off": "Off",
  "common.show": "Show",
  "common.hide": "Hide",
  "common.hint": "Hint",
  "common.showHint": "Show hint",
  "common.labelCountShowHint": "{label} {count}. Show hint",

  "duration.minutes_one": "{count} minute",
  "duration.minutes_other": "{count} minutes",
  "duration.hours_one": "{count} hour",
  "duration.hours_other": "{count} hours",

  "splash.description":
    "Aeterna Invicta strives to combine the best and most interesting aspects of Magic the Gathering and Path of Exile into a collectible card game. Build Decks, discover synergies, and play your cards right as you try to best your opponent.",
  "splash.tagline": "Become eternal and uncontested!",
  "splash.tutorials": "New Player? Click Here for Tutorials!",
  "splash.enterGame": "Enter Game",

  "nav.collapse": "Collapse navigation",
  "nav.expand": "Expand navigation",
  "nav.summary": "Summary",
  "nav.game": "Game",
  "nav.queue": "Queue",
  "nav.decks": "Decks",
  "nav.library": "Library",
  "nav.achievements": "Dailies and Achievements",
  "nav.customize": "Customize",
  "nav.marketplace": "Marketplace",
  "nav.social": "Social",
  "nav.ranking": "Ranking",
  "nav.settings": "Settings",
  "nav.workshop": "Workshop",
  "nav.community": "Community",
  "nav.support": "Support",

  "hud.gameLog": "Game Log",
  "hud.patchNotes": "Patch notes",
  "hud.showNavbar": "Show Navbar",
  "hud.hideNavbar": "Hide Navbar",
  "hud.queued": "Queued",
  "hud.forfeit": "Forfeit",
  "hud.leave": "Leave",
  "hud.leaveSpectate": "Leave spectate",
  "hud.serverMessages": "Server messages",
  "hud.serverMessagesNew": "Server messages (new)",

  "serverMessages.title": "Server Messages",
  "serverMessages.kindAdmin": "Server Message",
  "serverMessages.kindMaintenance": "Server Maintenance",
  "serverMessages.inProgress":
    "Server maintenance is in progress. The server may restart at any moment.",
  "serverMessages.beginsIn": "Server maintenance begins in",
  "serverMessages.empty": "No server messages right now.",
  "serverMessages.view": "View server messages",
  "serverMessages.template.patchApplied":
    "A new patch is live. Refresh the page or restart the app to load the latest version.",
  "serverMessages.template.maintenanceComplete":
    "Server maintenance is complete. Thanks for your patience!",
  "serverMessages.template.restartingNow":
    "The server is restarting now. You will reconnect automatically in a moment.",
  "serverMessages.template.maintenanceExtended":
    "Server maintenance is taking longer than expected. We will be back shortly.",
  "serverMessages.template.investigatingIssue":
    "We are aware of an issue and are investigating. Thanks for your patience.",
  "serverMessages.template.reportBugs":
    "Thanks for playing Aeterna Invicta! Please report any bugs from the Support page.",
  "serverMessages.template.maintenanceCountdown":
    "Server maintenance begins in {duration}. Please finish your matches before then.",
  "serverMessages.template.maintenanceStarting":
    "Server maintenance is starting now. The server may restart at any moment.",
  "serverMessages.template.maintenanceCancelled":
    "Scheduled server maintenance has been cancelled.",

  "completion.achievement": "Achievement Complete",
  "completion.daily": "Daily Complete",

  "settings.title": "Settings",
  "settings.backToMenu": "Back to Settings",
  "settings.section.account": "Account",
  "settings.section.general": "General",
  "settings.section.gameplay": "Gameplay",
  "settings.section.display": "Display",
  "settings.section.controls": "Controls & Accessibility",
  "settings.section.social": "Social & Privacy",
  "settings.section.danger": "Danger Zone",
  "settings.musicVolume.label": "Music Volume",
  "settings.soundVolume.label": "Sound Volume",
  "settings.volume.decrease": "Lower {label}",
  "settings.volume.increase": "Raise {label}",
  "settings.volume.description": "Saved on this device.",

  "settings.language.label": "Language",
  "settings.language.description":
    "Choose the language for menus and messages. Card names and card text stay in English.",

  "settings.account.label": "Account",
  "settings.account.guestSuffix": " (Guest)",
  "settings.account.guestDescription":
    "Guest progress lasts up to 24 hours. Logging out permanently deletes this guest save.",
  "settings.account.savedDescription":
    "Signed in with a saved account on this device.",
  "settings.account.createAndKeep": "Create Account & Keep Progress",
  "settings.account.migratePrompt":
    "Create an account and move your current progress onto it.",
  "settings.account.username": "Username",
  "settings.account.password": "Password",
  "settings.account.migrating": "Migrating…",
  "settings.account.createAccount": "Create Account",
  "settings.account.changePasswordPrompt": "Change your password.",
  "settings.account.currentPassword": "Current password",
  "settings.account.newPassword": "New password",
  "settings.account.confirmNewPassword": "Confirm new password",
  "settings.account.saving": "Saving…",
  "settings.account.updatePassword": "Update Password",
  "settings.account.changePassword": "Change Password",
  "settings.account.logOut": "Log Out",
  "settings.account.logOutGuestConfirm":
    "Log out and permanently delete this guest account and all of its progress?",
  "settings.account.logOutConfirm": "Log out of this account on this device?",
  "settings.account.confirmLogOut": "Confirm Log Out",

  "settings.music.label": "Music",
  "settings.music.description":
    "Play background music. Menu and match tracks are separate playlists that shuffle and crossfade, including when entering or leaving a match.",

  "settings.sound.label": "Sound",
  "settings.sound.description":
    "Play sound effects for draws and other match events.",
  "settings.sound.skipTrack": "Skip to Next Track",

  "settings.workshop.label": "Workshop",
  "settings.workshop.description":
    "Show or hide the Workshop button in the navigation bar.",

  "settings.quickUse.label": "Show Quick Use",
  "settings.quickUse.description":
    "Toggle showing an optional quick expend for resources and/or attack. This essentially helps you use equipment or abilities quickly if you don't care about quality, only efficiency.",

  "settings.hints.label": "Hints",
  "settings.hints.description":
    "Toggle contextual hint buttons during matches. Tap a ? icon for helper text about nearby UI.",

  "settings.matchGuides.label": "Match Guides",
  "settings.matchGuides.auto": "Auto",
  "settings.matchGuides.description":
    "Glow playable cards, usable equipment and abilities, and End Turn, with a collapsible helper box during matches vs CPU or players. Auto shows guides for guest accounts and your first {games} games.",

  "settings.cardNames.label": "Card Names",
  "settings.cardNames.description":
    "Show or hide names of cards in your hand and cards played into equipment slots.",

  "settings.leftHanded.label": "Left-Handed Mode",
  "settings.leftHanded.description":
    "Move the End Turn and Emote buttons to the left side and your hand to the right side during matches.",

  "settings.theme.label": "Theme",
  "settings.theme.dark": "Dark",
  "settings.theme.light": "Light",
  "settings.theme.description": "Toggle between different themes.",

  "settings.graphics.label": "Graphics Quality",
  "settings.graphics.auto": "Auto",
  "settings.graphics.high": "High",
  "settings.graphics.medium": "Medium",
  "settings.graphics.low": "Low",
  "settings.graphics.description":
    "Lower quality reduces background motion, animated foil, glows, and blur to keep matches smooth on slower devices. Auto picks a level for this device and steps down if matches stutter. Saved per device.",
  "settings.graphics.autoCurrent": "Currently using: {tier}.",
  "settings.graphics.autoLowered":
    "Graphics lowered to {tier} to keep the match smooth. You can change this in Settings.",

  "settings.foil.label": "Foil Effects",
  "settings.foil.minimum": "Minimum",
  "settings.foil.maximum": "Maximum",
  "settings.foil.description":
    "Maximum animates foil spotlight in Deck Builder, matches, and summary. Collection, Library, and other dense grids stay static. Minimum keeps foil looks static everywhere. Off keeps only static color treatments like grayscale or alternate color.",

  "settings.toasts.label": "Toasts",
  "settings.toasts.cardOnly": "Card Only",
  "settings.toasts.textOnly": "Text Only",
  "settings.toasts.all": "All",
  "settings.toasts.description":
    "Choose which match and action pop-ups appear. Off hides all toasts. Card Only shows small card previews. Text Only shows message toasts. All shows both.",

  "settings.toastSpeed.label": "Toast Speed",
  "settings.toastSpeed.fast": "Fast",
  "settings.toastSpeed.standard": "Standard",
  "settings.toastSpeed.description":
    "Fast shows toasts briefly, then fades them out. Standard keeps the usual hold time. Tap or click anytime to dismiss early.",
  "settings.handDisplay.label": "Hand Display",
  "settings.handDisplay.drawer": "Drawer",
  "settings.handDisplay.dynamic": "Dynamic",
  "settings.handDisplay.description":
    "Drawer keeps your hand fully visible; use the arrow beside it to slide the cards down to their names. Dynamic keeps the hand half hidden and raises a card when you hover or tap it.",
  "match.view.hideHand": "Hide hand",
  "match.view.showHand": "Show hand",

  "settings.fullscreen.label": "Force Full Screen",
  "settings.fullscreen.description":
    "Force full screen on desktop or mobile, which essentially hides the address/URL bar.",

  "settings.controller.label": "Controller",
  "settings.controller.connected": "Connected",
  "settings.controller.none": "None detected",
  "settings.controller.description":
    "D-pad moves through setting names. A opens that setting's choices, then A selects a value. Text fields open an on-screen keyboard (A types, B closes). Select or Start switches between the navbar and the current view.",

  "settings.chat.label": "Chat",
  "settings.chat.turnOff": "Turn Chat Off",
  "settings.chat.reviewTerms": "Review Chat Terms",
  "settings.chat.muted": "Chat has been disabled for your account.",
  "settings.chat.on":
    "Chat is on. Turn Chat Off hides all chat messages and stops you from sending them. You will need to review and accept the chat terms again to turn it back on.",
  "settings.chat.off":
    "Chat is off. Review and accept the chat terms to view and send messages.",
  "settings.chat.locked":
    "Chat is off. It unlocks after your account is at least 24 hours old, or after you complete {games} games without forfeiting.",

  "settings.blocked.label": "Blocked Players",
  "settings.blocked.unblock": "Unblock",
  "settings.blocked.description":
    "Blocked players' chat messages and match emotes are hidden from you, and they cannot challenge you. Block a player from their profile in Social, Ranking, chat, or the player preview during a match.",

  "settings.adventure.label": "Adventure",
  "settings.adventure.reset": "Reset Adventure",
  "settings.adventure.description":
    "Reset Adventure deletes your Adventure save and lets you start over entirely. If you have started a game in Adventure Mode, this will reset your entire Adventure save (a new Map, Inventory, no effects, etc.).",
  "settings.adventure.none": "No Adventure save to reset.",
  "settings.adventure.confirmTitle": "Reset Adventure?",
  "settings.adventure.confirmBody":
    "This permanently deletes your Adventure save, including your map progress, Inventory, Adventure Deck, Gold, and any active Adventure encounter or combat. You will start over from the beginning.",

  "settings.deleteAccount.label": "Delete Account",
  "settings.deleteAccount.description":
    "Permanently delete this account, login, and all progress. This cannot be undone.",
  "settings.deleteAccount.typeUsername": "Type your username ({username})",
  "settings.deleteAccount.deleting": "Deleting…",
  "settings.deleteAccount.forever": "Delete Account Forever",

  "deck.aspect": "Aspect",
  "deck.equipment": "Equipment",
  "deck.ability": "Ability",
  "deck.defaultName": "Deck",
  "deck.newDeck": "New Deck",
  "deck.totalPower": "Total Power",
  "deck.filters.allCards": "All cards",
  "deck.filters.allAttributes": "All attributes",
  "deck.attr.strength": "Strength",
  "deck.attr.dexterity": "Dexterity",
  "deck.attr.wisdom": "Wisdom",
  "deck.attr.neutral": "Neutral",
  "deck.filters.allResources": "All resources",
  "deck.filters.allCosts": "All costs",
  "deck.filters.allCostsResources": "All costs/resources",
  "deck.filters.fewer": "Fewer filters",
  "deck.filters.more": "More filters",
  "deck.filters.holoUnlocked": "Holo unlocked",
  "deck.filters.cardsUnlocked": "Cards: Unlocked",
  "deck.filters.cardsLocked": "Cards: Locked",
  "deck.filters.cardsAll": "Cards: All",
  "deck.filters.clear": "Clear filters",
  "deck.filters.searchPlaceholder": "Search name, effect, cost…",
  "deck.filters.allSlots": "All slots",
  "deck.filters.allItemTypes": "All equipment types",
  "deck.filters.allTiers": "All tiers",
  "deck.filters.allKinds": "All kinds",
  "deck.kind.active": "Active",
  "deck.kind.augment": "Augment",
  "deck.kind.essence": "Essence",
  "deck.filters.allTypes": "All types",
  "deck.filters.allEffects": "All effects",
  "deck.filters.sortBy": "Sort: {label}",
  "deck.catalog.resultCount_one": "{count} card",
  "deck.catalog.resultCount_other": "{count} cards",
  "deck.variant.label": "Variant",
  "deck.variant.base": "Base",
  "deck.variant.confirm": "Confirm",
  "deck.pager.previous": "Previous page",
  "deck.pager.next": "Next page",
  "deck.pager.pageOf": "Page {page}/{total}",
  "deck.pager.perPage": "{n} per page",
  "deck.pager.all": "All",
  "deck.share.exportTitle": "Export Deck",
  "deck.share.importTitle": "Import Deck",
  "deck.share.pastePlaceholder": "Paste deck JSON",
  "deck.share.copied": "Copied",
  "deck.share.copy": "Copy",
  "deck.share.import": "Import",
  "deck.analyze.none": "None",
  "deck.analyze.noOutputs": "No measurable action outputs.",
  "deck.analyze.output": "Output",
  "deck.analyze.avgPerCard": "Avg / card",
  "deck.analyze.total": "Total",
  "deck.analyze.sectionMeta": "{count} cards · Power {power}",
  "deck.analyze.avgCost": "Avg cost {cost}",
  "deck.analyze.kinds": "Kinds",
  "deck.analyze.boardSlots": "Board slots",
  "deck.analyze.equipmentSlots": "Equipment slots",
  "deck.analyze.attributes": "Attributes",
  "deck.analyze.typesPresent": "Types present",
  "deck.analyze.averageOutputs": "Average action outputs",
  "deck.analyze.title": "Analyze · {name}",
  "deck.analyze.overview": "{count} cards · Power {power}/{max}",
  "deck.analyze.attributesLabel": "Attributes:",
  "deck.analyze.typesLabel": "Types:",
  "deck.analyze.aspectMeta": "{name} · Power {power}",
  "deck.analyze.noneSelected": "None selected",
  "deck.analyze.types": "Types",
  "deck.analyze.pickAspect": "Pick an Aspect to include it here.",
  "deck.recommend.unknownCard": "Unknown card",
  "deck.recommend.title": "Recommend Changes · {name}",
  "deck.recommend.aspectUnchanged": "Aspect · Unchanged",
  "deck.recommend.swaps": "Swaps",
  "deck.recommend.loading": "Finding compatible swaps…",
  "deck.recommend.emptyTitle": "No compatible swaps found.",
  "deck.recommend.emptyBody": "None of your owned cards fit this deck better without losing slot coverage, resource support, or Power headroom. Your deck is unchanged.",
  "deck.recommend.staleNotice": "Your deck, card data, or collection changed since this preview.",
  "deck.recommend.recommendAgainHint": "Recommend again for fresh swaps.",
  "deck.recommend.exhausted": "No different swaps found. The last proposal is still shown.",
  "deck.recommend.equipmentSlot": "Equipment slot {n}",
  "deck.recommend.abilitySlot": "Ability slot {n}",
  "deck.recommend.remove": "Remove",
  "deck.recommend.add": "Add",
  "deck.recommend.whyAdd": "Why add",
  "deck.recommend.whyRemove": "Why remove",
  "deck.recommend.disclaimer": "Suggestions follow card links and aren't guaranteed upgrades. Applying updates the editor; Save to keep the changes.",
  "deck.recommend.apply": "Apply Changes",
  "deck.recommend.again": "Recommend Again",
  "deck.recommend.tryAgain": "Try Again",
  "deck.recommend.button": "Recommend Changes",
  "deck.recommend.buttonTitle": "Suggest 2–4 compatible card swaps",
  "deck.recommend.needsValidDeck": "Recommend Changes needs a complete, valid deck.",
  "deck.slot.empty": "Empty",
  "deck.slot.deckSlot": "Deck Slot",
  "deck.slot.clear": "Clear slot",
  "deck.slot.replaceCard": "Replace card",
  "deck.picker.replaceAspect": "Replace Aspect",
  "deck.picker.chooseAspect": "Choose Aspect",
  "deck.picker.replaceEquipmentSlot": "Replace equipment slot {n}",
  "deck.picker.chooseEquipmentSlot": "Choose equipment slot {n}",
  "deck.picker.replaceAbilitySlot": "Replace ability slot {n}",
  "deck.picker.chooseAbilitySlot": "Choose ability slot {n}",
  "deck.picker.hideFilters": "Hide filters/search",
  "deck.picker.showFilters": "Show filters/search",
  "deck.picker.suggest": "Suggest cards",
  "deck.sort.name": "Sort: Name",
  "deck.sort.type": "Sort: Type",
  "deck.sort.attribute": "Sort: Attribute",
  "deck.sort.resources": "Sort: Resources",
  "deck.sort.cost": "Sort: Cost",
  "deck.sort.power": "Sort: Power",
  "deck.sort.slot": "Sort: Slot",
  "deck.sort.kind": "Sort: Kind",
  "deck.sort.holo": "Sort: Holo count",
  "deck.builder.title": "Deck Builder",
  "deck.builder.setDefault": "Set Default",
  "deck.builder.clone": "Clone",
  "deck.builder.save": "Save",
  "deck.builder.delete": "Delete",
  "deck.builder.export": "Export",
  "deck.builder.analyze": "Analyze",
  "deck.builder.default": "Default",
  "deck.builder.unsaved": "Unsaved",
  "deck.builder.deleteTitle": "Delete Deck?",
  "deck.builder.deleteBody": "Permanently delete {name}. This cannot be undone.",
  "match.board.healthCost": "{amount} health",
  "match.board.alreadyPlayedAbility": "Already played ability this turn.",
  "match.board.tagInherent": "inherent",
  "match.board.tagCombo": "combo",
  "match.board.tagLevel": "Lv{level}",
  "match.board.tagActiveMinion": "Active {name} {hp}",
  "match.board.tagActiveAura": "Active {name}",
  "match.board.slotTitleCanLevelUp": "Can Level Up · select to view actions",
  "match.board.slotTitleEmpowerArmor": "Empower this Physical Armor card",
  "match.board.slotTitleLinkedAugment": "Linked augment match",
  "match.board.slotTitleSlotHere": "Slot ability here",
  "match.board.mismatch": "Mismatch",
  "match.board.expendedSuffix": " · expended",
  "match.board.auraActiveTitle": "{name} · Aura active",
  "match.board.linkedActiveUsed": "{name} · linked active used",
  "match.board.slotTitleInert": "{name} · inactive outside the host slot",
  "match.board.costTitle": "Cost {cost}",
  "match.board.emptyAbilitySlot": "Empty ability slot",
  "match.board.fletchCounter_one": "{count} Fletch Charge",
  "match.board.fletchCounter_other": "{count} Fletch Charges",
  "match.board.activeBadge": "Active",
  "match.board.you": "YOU",
  "match.board.opp": "OPP",
  "match.board.timerMulligan": "Mulligan timer",
  "match.board.timerTurn": "Turn timer",
  "match.board.timerMatch": "Match timer",
  "match.board.mulligan": "Mulligan",
  "match.board.yourTurn": "Your turn",
  "match.board.playerTurn": "{name}'s turn",
  "match.board.firstPlayerWillBe": "1st player will be {name} · ",
  "match.board.round": "Round {round}",
  "match.board.peekEquipment": "Equipment",
  "match.board.noEquipment": "No equipment",
  "match.board.peekAbilities": "Abilities",
  "match.board.noAbilities": "No abilities",
  "match.board.noOccupiedSlots": "No occupied slots",
  "match.board.healthOrbLabel": "Health {hp} of {maxHp}",
  "match.board.quests": "Quests",
  "match.board.tapAgainToExpend": "Tap again to expend: {action}",
  "match.board.targetAspect": "Target aspect",
  "match.board.aspect": "Aspect",
  "match.board.aspectSlotLabel": "Aspect slot",
  "match.board.aspectSlot": "Aspect Slot",
  "match.board.slotWeapon": "Weapon",
  "match.board.slotArmor": "Armor",
  "match.board.slotTrinket": "Trinket",
  "match.board.minion": "Minion",
  "match.board.aura": "Aura",
  "match.board.expend": "Expend",
  "match.board.minionHealthLabel": "{name} health {hp} of {maxHp}",
  "match.board.auraActiveLabel": "{name} active",
  "match.board.hexed": "Hexed",
  "match.board.expendCost": "Expend +{cost}",
  "match.board.equipHere": "Equip here",
  "match.board.slotTitle": "{slot} Slot",
  "match.board.slotAriaLabel": "{slot} slot",
  "match.board.quickRefresh": "REFRESH",
  "match.board.quickEncore": "ENCORE",
  "match.board.quickSlotDamage": "SLOT DMG",
  "match.board.quickRepair": "REPAIR",
  "match.board.gainResources": "Gain resources",
  "match.board.dealDamage": "Deal damage",
  "match.board.heal": "Heal",
  "match.board.physicalArmor": "Physical Armor",
  "match.board.magicArmor": "Magic Armor",
  "match.board.resolveTargetingFirst": "Resolve targeting first.",
  "match.board.equipmentBrokenCannotExpend": "That equipment is broken and cannot be expended.",
  "match.board.equipmentCannotExpend": "That equipment cannot be expended.",
  "match.board.refreshRequiresExpended": "Refresh requires expended equipment.",
  "match.board.cannotUseAction": "Cannot use that action.",
  "match.board.equipmentAction": "Equipment action",
  "match.board.notEnoughPhysicalArmor": "Not enough physical armor.",
  "match.board.examine": "Examine",
  "match.board.deactivateAura": "Deactivate Aura",
  "match.board.effectFallback": "Effect",
  "match.board.encore": "Encore",
  "match.board.slottedDamage": "+{amount} Slotted Damage",
  "match.board.repair": "Repair",
  "match.board.equipmentNotExpended": "Equipment is not expended.",
  "match.board.refresh": "Refresh",
  "match.board.charge": "Charge",
  "match.board.discard": "Discard",
  "match.board.levelUpAbility": "Level Up Ability",
  "match.board.empowerEquipment": "Empower Equipment",
  "match.board.empowerAbility": "Empower Ability",
  "match.board.unsummon": "Unsummon",
  "match.board.deactivate": "Deactivate",
  "match.board.alreadyActivated": "Already activated this turn.",
  "match.board.minionAlreadyActive": "Minion is already active.",
  "match.board.auraAlreadyActive": "Aura is already active.",
  "match.board.hostEquipmentOccupied": "Host equipment is occupied.",
  "match.board.unsummonMinionFirst": "Unsummon the minion first.",
  "match.board.deactivateAuraFirst": "Deactivate the aura first.",
  "match.board.moveAbility": "Move Ability",
  "match.board.remainingActs": "Remaining Acts:",
  "match.board.remainingEquip": "Equip",
  "match.board.remainingAbility": "Ability",
  "match.board.remainingExpendGear": "Expend Gear",
  "match.board.remainingActivateAbilities": "Activate Abl",
  "match.board.hintEquip": "Once per turn, equip an Equipment card from your hand onto an empty body slot.",
  "match.board.hintAbility": "Once per turn, slot an Ability from hand onto your board, or move a slotted Ability to an empty slot. Discarding a slotted Ability is free and does not use this action.",
  "match.board.hintExpendGear": "Each equipped item can be expended once per turn for resources or its expend effect. Multiple expend options on the same item still count as one.",
  "match.board.hintActivateAbilities": "Each unused slotted Active Ability that can still be activated this turn. Paying its cost is still required when you activate it.",
  "match.board.notEnoughResources": "Not enough resources.",
  "match.board.effectNumber": "Effect {number}",
  "match.board.actionNumber": "Action {number}",
  "match.board.noEmptyAbilitySlots": "No empty ability slots.",
  "match.board.selectEmptyAbilitySlot": "Select an empty ability slot.",
  "match.panel.aspect": "Aspect",
  "match.panel.aspectEmpty": "Aspect · Empty",
  "match.panel.equipment": "Equipment",
  "match.panel.slotEmpty": "{slot} · Empty",
  "match.panel.minion": "Minion",
  "match.panel.aura": "Aura",
  "match.panel.onEquipment": " · on {name}",
  "match.panel.charges": "Charges",
  "match.panel.durability": "Durability",
  "match.panel.broken": " (Broken)",
  "match.panel.unsummon": "Unsummon",
  "match.panel.deactivate": "Deactivate",
  "match.panel.gain": "Gain",
  "match.panel.toast.resolveTargetingFirst": "Resolve targeting first.",
  "match.panel.toast.notEnoughPhysicalArmor": "Not enough physical armor.",
  "match.panel.toast.refreshRequiresExpended": "Refresh requires expended equipment.",
  "match.panel.toast.equipmentCannotExpend": "That equipment cannot be expended.",
  "match.panel.toast.resolvePendingChoiceFirst": "Resolve pending choice first.",
  "match.panel.refresh": "Refresh",
  "match.panel.charge": "Charge",
  "match.panel.encore": "Encore",
  "match.panel.slottedDamageButton": "+{amount} Slotted Damage",
  "match.panel.repair": "Repair",
  "match.panel.discard": "Discard",
  "match.panel.examine": "Examine",
  "match.panel.traits": "Traits",
  "match.panel.aspectTraitTreeAria": "{name} trait tree",
  "match.panel.levelTrait": "Level {level} Trait",
  "match.panel.levelTraitLabel": "Level {level}: {label}",
  "match.panel.aspectBaseEffect": "Aspect base effect",
  "match.panel.allocated": "Allocated",
  "match.panel.traitOption": "Trait option",
  "match.panel.clickAnywhereToClose": "Click anywhere to close",
  "match.panel.tapNodeHint": "Tap a node to inspect Traits and the Aspect base effect.",
  "match.panel.viewArtAria": "View {name} art",
  "match.panel.variant": "Variant",
  "match.panel.variantBase": "Base",
  "match.panel.expansionSetAria": "{set} expansion set",
  "match.panel.set": "Set",
  "match.panel.power": "Power",
  "match.panel.attributes": "Attributes",
  "match.panel.attribute": "Attribute",
  "match.panel.kind": "Kind",
  "match.panel.linksTo": "Links To",
  "match.panel.or": "or",
  "match.panel.matchingActiveAbilities": "Matching Active abilities",
  "match.panel.slot": "Slot",
  "match.panel.boardSlotSub": "{slot} board slot",
  "match.panel.matchEffect": "Match Effect",
  "match.panel.passive": "Passive",
  "match.panel.kindEffect": "{kind} Effect",
  "match.panel.effect": "Effect",
  "match.panel.effectLower": "effect",
  "match.panel.triggers": "Triggers",
  "match.panel.expend": "Expend",
  "match.panel.equipmentActions": "Equipment Actions",
  "match.panel.cardText": "Card Text",
  "match.panel.invoke": "Invoke",
  "match.panel.levelProgression": "Level Progression",
  "match.panel.traitTree": "Trait Tree",
  "match.panel.tapArtToEnlarge": "Tap art to enlarge",
  "match.panel.ability": "Ability",
  "match.panel.health": "Health",
  "match.panel.expendedThisTurn": "Expended this turn",
  "match.panel.minions": "Minions",
  "match.panel.hostEquipment": "Host Equipment · {name}",
  "match.panel.appliedEffects": "Applied Effects",
  "match.panel.applyAbility": "Apply {name}",
  "match.panel.used": "Used",
  "match.panel.activeMinionStatus": "Active {name} {hp}",
  "match.panel.activeStatus": "Active {name}",
  "match.panel.mismatch": "Mismatch",
  "match.panel.level": "Level",
  "match.panel.baseLevel": "Base {level}",
  "match.panel.status": "Status",
  "match.panel.levelUpAbility": "Level Up Ability",
  "match.panel.exportGameLogTitle": "Download a JSON snapshot of the Game Log so far",
  "match.panel.exporting": "Exporting…",
  "match.panel.export": "Export",
  "match.panel.noActionsYet": "No actions yet.",
  "match.panel.quests": "Quests",
  "match.panel.eachTurn": "Each Turn",
  "match.panel.eachTurnHint": "Complete in any order. Resets at the start of your next turn.",
  "match.panel.duringGame": "During the Game",
  "match.panel.duringGameHint": "Complete once per match, in any order.",
  "match.panel.chooseSlottedResource": "Choose a resource matching a slotted ability.",
  "match.panel.convertNeutral": "Convert 1 Neutral into an attribute of your choice.",
  "match.panel.chooseFocusResourcePrompt": "Choose Strength, Dexterity, or Wisdom. Gain 1 of that resource.",
  "match.panel.chooseIdentity": "Choose Identity",
  "match.panel.chooseIdentityPrompt": "Choose Identity. This equipment becomes the chosen primary attribute while equipped.",
  "match.panel.levelUp": "Level Up",
  "match.panel.levelN": "Level {level}",
  "match.panel.tierN": "Tier {tier}",
  "match.panel.tier": "Tier",
  "match.panel.selected": "Selected",
  "match.panel.notChosen": "Not chosen",
  "match.panel.futureChoice": "Future choice",
  "match.panel.traitChoiceHint": "Select a glowing node, then Confirm to lock in your Trait.",
  "match.panel.traitTreeAria": "Trait tree",
  "match.panel.viewBoard": "View Board",
  "match.panel.confirmTrait": "Confirm Trait",
  "match.panel.clickOutsideToClose": "Click outside to close",
  "match.panel.showLevelUpPrompt": "Show Level Up prompt",
  "match.panel.hideLevelUpPrompt": "Hide Level Up prompt",
  "match.panel.levelUpAbilityPrompt": "Select a highlighted {attribute} Ability and choose Level Up Ability or Skip for +3 XP.",
  "match.panel.empowerPhysicalArmorCard": "Empower Physical Armor Card",
  "match.panel.empowerEquipment": "Empower Equipment",
  "match.panel.empowerPhysicalArmorHint": "Choose a yellow-highlighted slotted ability that grants Physical Armor to Level Up, or equipment whose expend effect grants Physical Armor to raise that expend armor by 1 (passive armor is unchanged), or Skip for +3 XP.",
  "match.panel.empowerEquipmentHint": "Choose a yellow-highlighted Wisdom equipment that grants Magic Armor to raise both its passive and expend Magic Armor by 1, or Skip for +3 XP.",
  "match.panel.chargeResourceSpend": "{label}: {current}. Spend {per} each to gain Strength, Dexterity, or Wisdom.",
  "match.panel.allocateUpTo": "Allocate up to {max}. Remaining {remaining}.",
  "match.panel.maxValue": "max {max}",
  "match.panel.confirm": "Confirm",
  "match.panel.payFor": "Pay for {name}",
  "match.panel.spendAnyFlex": "Spend any {amount} from strength, dexterity, wisdom, or neutral",
  "match.panel.remaining": "Remaining {amount}",
  "match.panel.decreaseAria": "Decrease {attribute}",
  "match.panel.increaseAria": "Increase {attribute}",
  "match.panel.hiddenCard": "Hidden card",
  "match.panel.discardAndDraw": "Discard & Draw",
  "match.panel.equip": "Equip",
  "match.panel.slotAction": "Slot",
  "match.panel.plusOnePhysArmor": "+1 Phys. Armor",
  "match.view.enemies": "Enemies",
  "match.view.statusBleed": "Bleed {amount}",
  "match.view.statusPoison": "Poison {amount}",
  "match.view.statusBurn": "Burn {amount}",
  "match.view.statusChill": "Chill {amount}",
  "match.view.statusShock": "Shock {amount}",
  "match.view.statusWither": "Wither {amount}",
  "match.view.statusHex": "Hex {amount}",
  "match.view.statusRegen": "Regen {amount}",
  "match.view.regeneration": "Regeneration",
  "match.view.wither": "Wither",
  "match.view.enemyDefeated": "Defeated",
  "match.view.enemySelectedTarget": "Selected target",
  "match.view.enemySelect": "Select enemy",
  "match.view.enemyExamine": "Examine enemy",
  "match.view.emptyEnemySlotAria": "Empty enemy slot {slot}",
  "match.view.emptySlot": "Empty",
  "match.view.matchOver": "Match Over",
  "match.view.waitingForSummary": "Waiting for summary…",
  "match.view.resultDraw": "Draw",
  "match.view.endedTimeout": "Timeout",
  "match.view.endedCombat": "Combat",
  "match.view.tutorialComplete": "Tutorial Complete",
  "match.view.tryAgain": "Try Again",
  "match.view.victory": "Victory",
  "match.view.defeat": "Defeat",
  "match.view.deckPower": "Power {total}/{max}",
  "match.view.deckAspectPower": "Aspect · Power {power}",
  "match.view.deckEquipmentPower": "Equipment ({cards}) · Power {power}",
  "match.view.deckAbilitiesPower": "Abilities ({cards}) · Power {power}",
  "match.view.noneRemaining": "None remaining",
  "match.view.you": "You",
  "match.view.winner": "Winner",
  "match.view.board": "Board",
  "match.view.handCount": "Hand ({n})",
  "match.view.deckCount": "Deck ({n})",
  "match.view.discardCount": "Discard ({n})",
  "match.view.continue": "Continue",
  "match.view.adNotCompleted": "Advertisement was not completed.",
  "match.view.adStartFailed": "Could not start advertisement.",
  "match.view.adExtraUnlock": "Watch an advertisement for an extra unlock",
  "match.view.unlockedCards_one": "Unlocked {count} card",
  "match.view.unlockedCards_other": "Unlocked {count} cards",
  "match.view.unlockedFoils_one": "Unlocked {count} foil reward",
  "match.view.unlockedFoils_other": "Unlocked {count} foil rewards",
  "match.view.bonusAvailable": "{bonus} bonus available",
  "match.view.earned": "Earned",
  "match.view.adPromptTitle": "Watch Advertisement?",
  "match.view.adPromptBody": "Would you like to watch a short advertisement to unlock additional foil variants of unlocked cards? We will use the money from advertising to support server costs and ongoing development. Thank you in advance for your support!",
  "match.view.loading": "Loading...",
  "match.view.adWatch": "Watch Advertisement",
  "match.view.notNow": "Not Now",
  "match.view.none": "None",
  "match.view.endedBy": "Ended by",
  "match.view.rounds": "Rounds",
  "match.view.opponent": "Opponent",
  "match.view.damageDealt": "Damage dealt",
  "match.view.damageTaken": "Damage taken",
  "match.view.healed": "Healed",
  "match.view.throwAway": "Throw Away",
  "match.view.reportChooseCategory": "Choose a report category.",
  "match.view.chatTurnedOff": "Chat is off. Review the chat terms to turn it back on.",
  "match.view.queueTitle": "Queueing for Match vs Player...",
  "match.view.playersInQueue": "Players in Queue: {players}",
  "match.view.cancelQueue": "Cancel Queue",
  "match.view.discardPileAria": "{name} discard pile",
  "match.view.discardViewerHint": "Most recent first. Tap a card to examine it.",
  "match.view.discardEmpty": "No cards in discard.",
  "match.view.account.passwordTooShort": "Password must be at least 4 characters.",
  "match.view.account.passwordMismatch": "New passwords do not match.",
  "match.view.account.passwordUpdated": "Password updated.",
  "match.view.account.changePasswordFailed": "Could not change password.",
  "match.view.account.requestFailed": "Request failed.",
  "match.view.account.typeUsernameToConfirm": "Type your username exactly to confirm.",
  "match.view.account.enterCurrentPassword": "Enter your current password.",
  "match.view.account.deleteFailed": "Could not delete account.",
  "match.view.account.enterUsername": "Enter a username.",
  "match.view.account.usernameNoSpaces": "Username must not contain spaces.",
  "match.view.account.createFailed": "Could not create account.",
  "match.view.winnerBanner": "Winner: {name}",
  "match.view.quickUseEquipment": "Quick Use Equipment for Resources",
  "match.view.quickUseAbilities": "Quick Use Damage Abilities",
  "match.view.hand": "Hand",
  "match.view.noCardsInHand": "No Cards in Hand",
  "match.view.handHint": "This is your hand. Your equipment and ability decks are shuffled together. You can have up to four cards in hand, replenished up to max at the start of each of your turns. You can equip one equipment card per turn, and perform one ability play per turn: slot into an empty slot, move a slotted ability, or unslot back to hand.",
  "match.guide.label": "Guide",
  "match.guide.show": "Show guide",
  "match.guide.hide": "Minimize guide",
  "match.guide.turnOff": "Turn off guides",
  "match.guide.turnedOff": "Match guides off. Turn them back on in Settings.",
  "match.guide.title.openingHand": "Opening Hand",
  "match.guide.title.yourTurn": "Your Turn",
  "match.guide.title.opponentTurn": "Opponent's Turn",
  "match.guide.title.makeChoice": "Make a Choice",
  "match.guide.mulligan": "Keep this hand, or press Mulligan once to redraw. Press Ready when you're set.",
  "match.guide.mulliganWaiting": "Waiting for your opponent to get ready.",
  "match.guide.opponentTurn": "Watch what your opponent plays. Tap any card to examine it. Your hand refills at the start of your turn.",
  "match.guide.pendingChoice": "Finish the highlighted choice (pick a target or option), or cancel it, before doing anything else.",
  "match.guide.playEquipment": "Equip: tap a glowing Equipment card in your hand and press Equip (1 per turn).",
  "match.guide.slotAbility": "Ability: tap a glowing Ability card in your hand, press Slot, then pick an empty ability slot (1 per turn).",
  "match.guide.expendEquipment_one": "Expend: tap the glowing equipment on your board for resources or its effect.",
  "match.guide.expendEquipment_other": "Expend: tap glowing equipment on your board for resources or effects ({count} ready).",
  "match.guide.activateAbilities_one": "Activate: tap the glowing ability on your board to use it.",
  "match.guide.activateAbilities_other": "Activate: tap glowing abilities on your board to use them ({count} ready).",
  "match.guide.needResources": "Some abilities need more resources. Expend equipment first to pay for them.",
  "match.guide.nothingLeft": "Nothing left to play or use. Press End Turn.",
  "match.guide.idle": "Stuck? You can press End Turn anytime.",
  "match.guide.invoke": "Optional: Invoke one card from your hand, discarding it for its Invoke effect.",
  "match.view.viewingYourBoard": "Viewing Your Board",
  "match.view.viewingEnemies": "Viewing Enemies",
  "match.view.viewingPlayerBoard": "Viewing {name}'s Board",
  "match.view.cycleBoardView": "Cycle board view",
  "match.view.viewLabel": "View",
  "match.view.viewEnemy": "Enemy",
  "match.view.viewAlly": "Ally",
  "match.view.viewOpp": "Opp",
  "match.view.viewSelf": "Self",
  "match.view.showMatchEmotes": "Show match emotes",
  "match.view.hideAllMatchEmotes": "Hide all match emotes",
  "match.view.showEmotes": "Show Emotes",
  "match.view.hideEmotes": "Hide Emotes",
  "match.view.emotes": "Emotes",
  "match.view.sendEmote": "Send emote {emoji}",
  "match.view.mulliganed": "Mulliganed",
  "match.view.mulligan": "Mulligan",
  "match.view.closeEmotes": "Close emotes",
  "match.view.openEmotes": "Open emotes",
  "match.view.emote": "Emote",
  "match.view.ready": "Ready",
  "match.view.cancelEffectUse": "Cancel Effect Use",
  "match.view.cancelAbilityUse": "Cancel Ability Use",
  "match.view.cancelEffectUseConfirm": "Cancel Effect Use?",
  "match.view.cancelAbilityUseConfirm": "Cancel Ability Use?",
  "match.view.skipAbilityLevelUpTitle": "Skip Ability Level Up for +3 XP",
  "match.view.skip": "SKIP",
  "match.view.chooseAbilityOrSkipTitle": "Choose a highlighted Ability or Skip before ending your turn",
  "match.view.endTurnLine1": "END",
  "match.view.endTurnLine2": "TURN",
  "match.view.skipEquipmentTraitTitle": "Skip equipment Trait for +3 XP",
  "match.view.chooseAbilityOrEquipmentOrSkipTitle": "Choose highlighted ability or equipment or Skip before ending your turn",
  "match.view.chooseEquipmentOrSkipTitle": "Choose highlighted equipment or Skip before ending your turn",
  "match.view.chooseTraitLine1": "Choose",
  "match.view.chooseTraitLine2": "Trait",
  "match.view.viewBoardLine1": "View",
  "match.view.viewBoardLine2": "Board",
  "match.view.chooseTraitTitle": "Choose a Trait before ending your turn",
  "match.view.chooseIdentityLine1": "Choose",
  "match.view.chooseIdentityLine2": "Identity",
  "match.view.chooseIdentityTitle": "Choose an Identity before ending your turn",
  "match.view.noResourcesSpent": "No resources will be spent.",
  "match.view.noRefund": "You will not be refunded the cost of {name}.",
  "match.view.thisEffect": "this effect",
  "match.view.keepTargeting": "Keep Targeting",
  "game.toast.error": "Error",
  "game.toast.yourTurn": "Your Turn",
  "game.toast.yourTurnOpeningBlocked": "Your Turn · You play first, so you deal no damage on your first turn",
  "game.gameLog.exportFailed": "Could not export Game Log.",
  "game.gameLog.copied": "Game Log copied to clipboard ({entries} entries)",
  "game.gameLog.exported": "Game Log exported ({entries} entries)",
  "game.payment.kind.ability": "Ability",
  "game.payment.kind.sharpen": "Sharpen",
  "game.payment.kind.hone": "Hone",
  "game.payment.kind.fletch": "Fletch",
  "game.payment.kind.encore": "Encore",
  "game.payment.kind.research": "Research",
  "game.payment.kind.repair": "Repair",
  "game.deck.recommendStale": "Your deck changed. Recommend again for fresh swaps.",
  "game.deck.recommendInvalid": "These swaps are no longer valid.",
  "game.deck.recommendApplied_one": "Applied {count} swap. Save to keep them.",
  "game.deck.recommendApplied_other": "Applied {count} swaps. Save to keep them.",
  "game.deck.limitReached": "Deck limit reached.",
  "game.deck.imported": "Imported {name}",
  "game.workshop.seatOpponent": "Opponent",
  "game.workshop.seatYou": "You",
  "game.workshop.maxCopies": "Max {max} copies of {name}.",
  "game.workshop.addedToAbilityHand": "Added to ability hand. Select a slot.",
  "common.attribute.strength": "Strength",
  "common.attribute.dexterity": "Dexterity",
  "common.attribute.wisdom": "Wisdom",
  "common.attribute.neutral": "Neutral",
  "deck.sort.name": "Name",
  "deck.sort.category": "Category",
  "deck.sort.type": "Type",
  "deck.sort.attribute": "Attribute",
  "deck.sort.resources": "Resources",
  "deck.sort.cost": "Cost",
  "deck.sort.power": "Power",
  "deck.sort.slot": "Slot",
  "deck.sort.tier": "Tier",
  "deck.sort.kind": "Kind",
  "deck.sort.holo": "Holo count",
  "match.quest.equip": "Equip an Equipment Card",
  "match.quest.slotAbility": "Slot an Ability Card",
  "match.quest.resourceExpend": "Gain at least 1 resource",
  "match.quest.combatDamage": "Deal unblocked damage",
  "match.quest.healBuff": "Gain a support effect such as healing or armor",
  "match.quest.fullEquipment": "Have an equipment equipped in all 3 slots at one time",
  "match.quest.fullAbilities": "Have an ability slotted in all 3 active or main slots at one time",
  "match.quest.equipAllSlots": "Equip each equipment slot at least once",
  "match.quest.activateLevel2Ability": "Activate a slotted Level 2 Ability once",
  "match.quest.activateAugmentedAbility": "Activate an Ability with a matching Augment once",
  "match.questStep.weapon": "Weapon",
  "match.questStep.trinket": "Trinket",
  "match.questStep.body": "Body",
  "match.questStep.hands": "Hands",
  "match.questStep.feet": "Feet",
  "match.questStep.head": "Head",
  "game.serverToast.mulliganFirstPlayer": "MULLIGAN PHASE - First player will be {name}",
  "game.serverToast.ranOutOfTime": "You ran out of time!",
  "match.lobby.backToMatch": "Back to Match",
  "match.lobby.classic": "Classic",
  "match.lobby.queueVsCpu": "Queue vs CPU",
  "match.lobby.vsCpu": "VS CPU",
  "match.lobby.playersInQueue_one": "Players in Queue: {count}",
  "match.lobby.playersInQueue_other": "Players in Queue: {count}",
  "match.lobby.queueVsHuman": "Queue vs Player",
  "match.lobby.vsHuman": "VS Player",
  "match.lobby.cancelQueue": "Cancel Queue",
  "match.lobby.enterQueueVsHuman": "Enter Queue vs Player",
  "match.lobby.playAgainstCpu": "Play Against CPU",
  "match.lobby.setValidDeck": "Set a valid deck before queueing.",
  "match.lobby.currentDeck": "Current Deck:",
  "match.lobby.randomDeck": "🎲 Random Deck",
  "match.lobby.randomDeckHint": "A random valid deck will be chosen when you queue.",
  "match.lobby.deckPreview": "Deck Preview",
  "match.lobby.noAspect": "No aspect",
  "match.lobby.modes": "Modes",
  "match.lobby.collectDraftRewards": "Collect Draft Rewards",
  "match.lobby.continueDraftMode": "Continue Draft Mode",
  "match.lobby.playDraftModeFree": "Play Draft Mode (FREE)",
  "match.lobby.playDraftModeCost": "Play Draft Mode ({cost} currency)",
  "match.lobby.collectDraft": "Collect Draft",
  "match.lobby.continueDraft": "Continue Draft",
  "match.lobby.draftFree": "Draft (FREE)",
  "match.lobby.draft": "Draft",
  "match.lobby.continueAdventureMode": "Continue Adventure Mode",
  "match.lobby.playAdventureMode": "Play Adventure Mode",
  "match.lobby.continueAdventure": "Continue Adventure",
  "match.lobby.adventure": "Adventure",
  "match.lobby.tutorialScenarios": "Tutorial Scenarios",
  "match.lobby.tutorials": "Tutorials",
  "match.lobby.draftStatus": "Draft: {lives} lives · {played}/{max} games · W {wins} / L {losses} / D {draws}",
  "match.lobby.draftRound": "Draft: Round {round}/{total}",
  "match.lobby.collectDraftFirst": "Collect Draft rewards before starting a new run.",
  "match.popup.challengeTitle": "Challenge",
  "match.popup.challengeBody": "{name} challenged you to a game.",
  "match.popup.partyInviteTitle": "Party Invite",
  "match.popup.partyInviteBody": "{name} invited you to an Adventure party.",
  "match.popup.leaveCpuTitle": "Leave CPU match?",
  "match.popup.leaveCpuBody": "Forfeit the match and leave this game to accept challenge?",
  "match.popup.accept": "Accept",
  "match.popup.decline": "Decline",
  "match.popup.leaveSpectateTitle": "Leave spectator mode?",
  "match.popup.forfeitTitle": "Forfeit match?",
  "match.popup.leaveSpectateBody": "You will stop spectating this game.",
  "match.popup.forfeitBody": "You will lose this match and leave immediately.",
  "match.popup.leave": "Leave",
  "match.popup.forfeit": "Forfeit",
  "match.popup.loseTitle": "This will cause you to lose",
  "match.popup.loseBodyEquip": "Equipping {name} will cause you to lose.",
  "match.popup.loseBodyActivate": "Activating {name} will cause you to lose.",
  "match.popup.confirm": "Confirm",
  "match.popup.disconnected": "Disconnected",
  "match.popup.reconnecting": "You were disconnected, attempting reconnection...",
  "match.popup.hideHint": "Hide hint",
  "common.back": "Back",
  "common.returnToMenu": "Return to Menu",
  "common.currencyAmount": "{amount} currency",
  "draft.title": "Draft Mode",
  "draft.draftedCards": "Current Drafted Cards",
  "draft.aspectCount": "Aspect ({n})",
  "draft.equipmentCount": "Equipment ({n})",
  "draft.abilityCount": "Ability ({n})",
  "draft.noneYet": "None yet.",
  "draft.roundChoice": "Round {round}/{total} · {kind} Choice",
  "draft.forfeit": "Forfeit Draft",
  "draft.pick": "Draft",
  "draft.forfeitTitle": "Forfeit Draft?",
  "draft.forfeitBody": "This ends the entire draft run.",
  "draft.deckTitle": "Draft Deck",
  "draft.deckStatus": "Lives {lives}/{maxLives} · Games {played}/{maxGames} · W {wins} / L {losses} / D {draws}",
  "draft.deckCounts": "Aspect {aspect}/1 · Equipment {equipment}/{min} · Ability {ability}/{min} · Pool {poolAspect} aspect / {poolEquipment} equipment / {poolAbility} ability",
  "draft.queueCpu": "Queue Draft Match vs CPU",
  "draft.queueHuman": "Queue for Draft Match vs Human",
  "draft.buildHint": "Build a 10 equipment / 10 ability deck from your drafted cards.",
  "draft.complete": "Draft Complete",
  "draft.collectRewards": "Collect Rewards",
  "draft.livesRemaining": "Lives remaining {lives}",
  "draft.record": "W {wins} / L {losses} / D {draws}",
  "draft.games": "Games {games}",
  "draft.reward": "Reward",
  "draft.wizardFoils": "Draft Wizard foils {n}",
  "draft.deckAspect": "Deck Aspect",
  "draft.deckEquipment": "Deck Equipment",
  "draft.deckAbility": "Deck Ability",
  "draft.poolAspect": "Pool Aspect",
  "draft.poolEquipment": "Pool Equipment",
  "draft.poolAbility": "Pool Ability",
  "draft.costToast": "Draft Mode costs {cost} currency (or free once per day after 4:00 PM Central).",
  "adventure.title": "Adventure Mode",
  "adventure.hp": "{hp}/{maxHp} HP",
  "adventure.gold": "Gold {gold}",
  "adventure.intention": "Intention: {intention}",
  "adventure.actsEvery_one": "Acts every {count} turn",
  "adventure.actsEvery_other": "Acts every {count} turns",
  "adventure.nextSuffix": " (next)",
  "adventure.intentNext": "Next: {summary}",
  "adventure.intentIn": "In {turns}: {summary}",
  "adventure.unknown": "Unknown",
  "adventure.attack": "Attack",
  "adventure.attackDamage": "{damage} {type} damage",
  "adventure.attackHeal": "heal {heal} ({target})",
  "adventure.healTargetAllies": "all allies",
  "adventure.healTargetAlly": "an ally",
  "adventure.healTargetSelf": "self",
  "adventure.damageType.physical": "physical",
  "adventure.damageType.magical": "magical",
  "adventure.damageType.fire": "fire",
  "adventure.damageType.cold": "cold",
  "adventure.damageType.lightning": "lightning",
  "adventure.enemy": "Enemy",
  "adventure.enemyType": "Type: {name}",
  "adventure.node": "Node",
  "adventure.nodeType.start": "Camp",
  "adventure.nodeType.combat": "Combat",
  "adventure.nodeType.shop": "Shop",
  "adventure.nodeType.reward": "Treasure",
  "adventure.nodeType.story": "Story",
  "adventure.preview.unknown": "Unknown encounter.",
  "adventure.preview.combat": "A combat encounter.",
  "adventure.preview.shop": "A shop.",
  "adventure.preview.reward": "A treasure cache.",
  "adventure.preview.story": "A story event.",
  "adventure.chooseNodeTitle": "Choose {name}?",
  "adventure.travelNodeTitle": "Travel to {name}?",
  "adventure.chooseUnknownTitle": "Choose unknown node?",
  "adventure.travelUnknownTitle": "Travel to unknown node?",
  "adventure.pathHidden": "The path ahead is hidden until you arrive.",
  "adventure.partyMustConfirm": "Party members must confirm before the event begins.",
  "adventure.fillDeckBeforeTravel": "Fill your Adventure Deck with 10 equipment and 10 ability cards before traveling.",
  "adventure.choose": "Choose",
  "adventure.travel": "Travel",
  "adventure.fillEverySlot": "Fill every Adventure Deck slot with cards from Inventory before traveling. Each deck needs 10 cards with at most {max} copies of the same card.",
  "adventure.waitingPartyConfirm": "Waiting for party confirm ({ready}/{total})",
  "adventure.confirmReady": "Confirm Ready",
  "adventure.effects": "Effects",
  "adventure.activeEffects": "Active Effects",
  "adventure.noActiveEffects": "No active effects.",
  "adventure.inventoryCount": "Inventory {n}/{max}",
  "adventure.defaultDeckName": "Journeyman's Pack",
  "adventure.deckCounts": "{name} · Aspect {aspect}/1 · Equipment {equipment}/{min} · Ability {ability}/{min}",
  "adventure.deckEditHint": "Tap a slot to examine, clear, or replace it with a card from Inventory. Fill every slot with at most {max} copies of each card to travel again.",
  "adventure.leave": "Leave",
  "adventure.take": "Take",
  "adventure.party": "Party",
  "adventure.partyHint": "Invite players who are Online in the Adventure Mode menu. Up to 4.",
  "adventure.partyLeader": "Leader: {name}",
  "adventure.leaderSuffix": " (Leader)",
  "adventure.invitedYou": "{name} invited you",
  "adventure.invite": "Invite",
  "adventure.noEligible": "No eligible players online.",
  "adventure.leaveParty": "Leave Party",
  "adventure.waitingParty": "Waiting for party…",
  "adventure.combatSummary": "Combat Summary",
  "adventure.resultGold": "{result} · Gold earned {gold}",
  "adventure.enemiesDefeated_one": "{defeated} of {count} enemy defeated",
  "adventure.enemiesDefeated_other": "{defeated} of {count} enemies defeated",
  "adventure.rewards": "Rewards",
  "adventure.rewardHint": "Tap a card to examine · Click Take to queue a reward, or Leave to skip it",
  "adventure.continueWhenReady": "Continue when ready",
  "adventure.resolvingCombat": "Resolving combat...",
  "adventure.shop": "Shop",
  "adventure.shopHint": "Gold {gold} · Tap a card to examine",
  "adventure.buyGold": "Buy {price} Gold",
  "adventure.leaveShopWhenReady": "Leave shop when ready",
  "adventure.leaveShop": "Leave Shop",
  "adventure.treasure": "Treasure",
  "adventure.treasureHint": "Gold {gold} · Tap a card to examine · Click Take to queue a reward, or Leave to skip it",
  "adventure.story": "Story",
  "adventure.youGain": "You gain: {effects}",
  "adventure.enteringCombat": "Entering combat…",
  "adventure.tabDeck": "Adventure Deck",
  "adventure.tabInventory": "Inventory",
  "adventure.tabMap": "Map",
  "common.player": "Player",
  "common.hoursMinutesShort": "{hours}h {minutes}m",
  "common.minutesShort": "{minutes}m",
  "social.report": "Report",
  "social.block": "Block",
  "customize.board": "Board",
  "customize.nameColor": "Name Color",
  "customize.lockedSuffix": " (Locked)",
  "customize.unlockFor": "Unlock {name} for {cost}",
  "customize.confirmPurchase": "Tap again to buy",
  "customize.boardName.flat": "Flat",
  "customize.boardName.elegant": "Elegant",
  "customize.boardName.ice": "Ice",
  "customize.boardName.nature": "Nature",
  "customize.boardName.volcanic": "Volcanic",
  "customize.boardName.castle": "Castle",
  "customize.boardName.factory": "Factory",
  "customize.boardName.swamp": "Swamp",
  "customize.colorName.garnet": "Garnet",
  "customize.colorName.scarlet": "Scarlet",
  "customize.colorName.amber": "Amber",
  "customize.colorName.gold": "Gold",
  "customize.colorName.verdant": "Verdant",
  "customize.colorName.forest": "Forest",
  "customize.colorName.abyss": "Abyss",
  "customize.colorName.steel": "Steel",
  "customize.colorName.mist": "Mist",
  "customize.colorName.white": "White",
  "customize.colorName.cyan": "Cyan",
  "customize.colorName.azure": "Azure",
  "customize.colorName.sand": "Sand",
  "customize.colorName.clay": "Clay",
  "customize.colorName.umber": "Umber",
  "customize.colorName.plum": "Plum",
  "customize.colorName.rainbow_holo": "Rainbow Holo",
  "customize.colorName.metallic_holo": "Metallic Holo",
  "customize.colorName.gilded_holo": "Gilded Holo",
  "marketplace.refreshesIn": "Refreshes in {time}",
  "marketplace.cards": "Cards",
  "marketplace.foils": "Foil Variants",
  "marketplace.sold": "Sold",
  "marketplace.buy": "Buy",
  "marketplace.confirmBuy": "Confirm Buy",
  "marketplace.noCards": "No locked cards available.",
  "marketplace.noFoils": "No foil variants available.",
  "marketplace.notEnough": "Not enough currency.",
  "achievements.title": "Achievements",
  "achievements.close": "Close achievements",
  "achievements.ready": "{n} ready",
  "achievements.completionReward": "Completion reward",
  "achievements.completionRewardCollected": "Completion reward collected",
  "achievements.none": "No achievements yet.",
  "achievements.collected": "Collected",
  "achievements.collect": "Collect",
  "achievements.collectCompletionTitle": "Collect the completion reward",
  "achievements.collectAllFirst": "Collect every achievement in this category first.",
  "achievements.view": "View Achievements",
  "achievements.dailies": "Dailies",
  "achievements.dailiesHint": "Gain progress toward dailies in any Classic Match",
  "achievements.emptySlot": "Empty Slot",
  "achievements.untilNewDaily": "{time} until new daily",
  "achievements.newDailyArriving": "New daily arriving...",
  "achievements.untilExpired": "{time} until expired",
  "achievements.removeAgainAria": "Press again to remove daily: {label}",
  "achievements.removeAria": "Remove daily: {label}",
  "achievements.removeAgain": "Press again to remove",
  "achievements.remove": "Remove daily",
  "achievements.rerollAgainAria": "Press again to re-roll daily for {cost} currency: {label}",
  "achievements.rerollAria": "Re-roll daily for {cost} currency: {label}",
  "achievements.rerollAgain": "Press again to re-roll",
  "achievements.reroll": "Re-roll this daily (once per daily)",
  "achievements.loadingDailies": "Loading dailies...",
  "dailies.dealDamage": "Deal {target} {type} damage",
  "dailies.applyAilment": "Apply {target} {ailment}",
  "dailies.gainResource": "Gain {target} {attribute}",
  "dailies.playEquipment": "Play {target} Equipment cards",
  "dailies.playAbility": "Play {target} Ability cards",
  "dailies.playAttribute": "Play {target} {attribute} cards",
  "dailies.playKind": "Play {target} {kind} abilities",
  "dailies.playTag": "Play {target} {tag} cards",
  "dailies.winWithAspect_one": "Win {count} game with {name}",
  "dailies.winWithAspect_other": "Win {count} games with {name}",
  "dailies.expendDamage": "Expend equipment {target} times for damage",
  "dailies.expendEffect": "Expend equipment {target} times for a non-damage, non-resource effect",
  "dailies.activateAbility": "Activate an active ability {target} times",
  "dailies.invokeCards": "Invoke {target} cards",
  "dailies.activateCard": "Activate {name} {target} times",
  "dailies.ailment.burn": "Burn",
  "dailies.ailment.poison": "Poison",
  "dailies.ailment.bleed": "Bleed",
  "dailies.ailment.shock": "Shock",
  "dailies.ailment.chill": "Chill",
  "dailies.ailment.wither": "Wither",
  "match.portrait.closeAria": "Close player exam",
  "match.portrait.deck": "Deck: {n}",
  "match.portrait.hand": "Hand: {n}",
  "match.portrait.discard": "Discard: {n}",
  "common.loading": "Loading…",
  "common.ok": "OK",
  "common.loadingAssets": "Loading assets {loaded}/{total}",
  "social.chatMuted": "You are muted and cannot view or send chat messages.",
  "social.chatGuest":
    "Chat requires a registered account. Create or migrate to an account in Settings, then return here.",
  "social.chatLocked":
    "Chat unlocks after your account is at least 24 hours old, or after you complete {games} games without forfeiting. Progress: {completed}/{games} completed games.",
  "social.chatLockedRemaining":
    "Chat unlocks after your account is at least 24 hours old, or after you complete {games} games without forfeiting. Progress: {completed}/{games} completed games ({remaining} remaining).",
  "social.chatAgreeTerms":
    "Agree to the in-game chat terms to view and send messages.",
  "social.players": "Players",
  "social.playersOnline": "{online} / {total} online",
  "social.showPlayers": "Show players",
  "social.hidePlayers": "Hide players",
  "social.noPlayers": "No players.",
  "social.noMessages": "No messages yet.",
  "social.messagePlaceholder": "Message",
  "social.reportTitle": "Report {name}",
  "social.reportPrompt":
    "What is the problem? Reports are private and reviewed by ATN DEV.",
  "social.reportCategory": "Report category",
  "social.reportCategoryName.harassment": "Harassment, Bullying, or Threats",
  "social.reportCategoryName.hate": "Hate Speech or Discrimination",
  "social.reportCategoryName.inappropriate": "Sexual or Inappropriate Content",
  "social.reportCategoryName.spam": "Spam or Scams",
  "social.reportCategoryName.cheating": "Cheating or Exploiting",
  "social.reportCategoryName.username": "Offensive Username",
  "social.reportCategoryName.other": "Other",
  "social.reportDetails": "Details (optional)",
  "social.reportDetailsPlaceholder": "Briefly describe what happened.",
  "social.reportChatIncluded":
    "Recent chat messages from this player are included with your report.",
  "social.reportBlockHint":
    "You can also block {name} to hide their chat messages and emotes.",
  "social.sending": "Sending…",
  "social.submitReport": "Submit Report",
  "social.optIn.title": "Optional In-Game Chat",
  "social.optIn.optional":
    "In-game chat is optional. By agreeing, you opt in to view and send player-generated messages.",
  "social.optIn.notMonitored":
    "Messages are created by players and do not represent ATN DEV. Chat is not necessarily monitored before it appears. Do not assume chat is private or confidential.",
  "social.optIn.conduct":
    "Do not use chat for threats, harassment, hate, scams, spam, illegal activity, or other prohibited conduct. ATN DEV may review reports and may warn, restrict chat, suspend, or ban accounts.",
  "social.optIn.sensitive":
    "Do not share passwords, financial information, or other sensitive personal information in chat.",
  "social.optIn.detailsBefore": "Full details are in the ",
  "social.optIn.detailsAfter": ".",
  "social.optIn.agree": "I Agree",
  "social.status.online": "Online",
  "social.status.offline": "Offline",
  "social.status.recentlyOnline": "Recently Online",
  "social.status.inCpuGame": "In CPU Game",
  "social.status.inGame": "In Game",
  "social.status.spectating": "Spectating",
  "social.status.inDraftQueue": "In Draft Queue",
  "social.status.inQueue": "In Queue",
  "social.status.viewingQueue": "Viewing Queue",
  "social.status.deckEditing": "Deck Editing",
  "social.status.viewingCollection": "Viewing Collection",
  "social.status.viewingLibrary": "Viewing Library",
  "social.status.viewingAchievements": "Viewing Achievements",
  "social.status.viewingGlossary": "Viewing Glossary",
  "social.status.adjustingSettings": "Adjusting Settings",
  "social.status.customizingBoard": "Customizing Board",
  "social.status.inMarketplace": "In Marketplace",
  "social.status.inSocial": "In Social",
  "social.status.viewingRanking": "Viewing Ranking",
  "social.status.inWorkshop": "In Workshop",
  "social.status.viewingCommunity": "Viewing Community",
  "social.status.viewingSupport": "Viewing Support",
  "social.status.viewingTutorials": "Viewing Tutorials",
  "social.status.viewingSummary": "Viewing Summary",
  "social.status.drafting": "Drafting",
  "social.status.buildingDraftDeck": "Building Draft Deck",
  "social.status.viewingDraftSummary": "Viewing Draft Summary",
  "social.status.adventureMode": "Adventure Mode",
  "social.status.adventureCombatSummary": "Adventure Combat Summary",
  "social.status.inAdmin": "In Admin",
  "social.status.watchingReplay": "Watching Replay",
  "social.draftMode": "Draft Mode",
  "social.bestDraftRun":
    "Best run W {wins} / L {losses} / D {draws} · {lives} lives · {games} games",
  "social.draftPool": "Draft Pool",
  "social.noDraftRun": "No completed draft run.",
  "social.spectateGame": "Spectate Game",
  "social.blockedNotice":
    "You have blocked this player. Their chat messages and emotes are hidden, and they cannot challenge you.",
  "social.noDecks": "No decks.",
  "social.deckEquipmentPower": "Equipment · Power {power}",
  "social.deckAbilitiesPower": "Abilities · Power {power}",
  "ranking.cpuWinRatio": "CPU win ratio",
  "ranking.humanWinRatio": "Human win ratio",
  "ranking.cpuRecord": "CPU W/L/T",
  "ranking.humanRecord": "Human W/L/T",
  "ranking.prev": "Prev",
  "ranking.next": "Next",
  "community.discordCopy": "Join the Discord for Random's Projects.",
  "community.joinDiscord": "Join Discord",
  "support.contactTitle": "Contact for Support or Bug Reporting",
  "support.contactCopy": "Reach us by email for help or to report a problem.",
  "support.privacyPolicy": "Privacy Policy",
  "support.privacyCopy":
    "What information we collect, who receives it, how long we keep it, and how to delete your account and data.",
  "support.privacyTitle": "Privacy and Data Safety",
  "support.privacyHighlightCollect":
    "We collect your username, a hashed password, game progress, and your IP address with approximate location. No email is required, and there are no analytics or ad SDKs.",
  "support.privacyHighlightShare":
    "We do not sell personal data. Only our hosting, IP geolocation, and email providers process it on our behalf.",
  "support.privacyHighlightChat":
    "Chat is opt-in, visible to players with chat on, and deleted after 90 days at the latest.",
  "support.privacyHighlightDelete":
    "Delete your account any time in Settings > Account, on the web, or by email.",
  "support.privacyRead": "Read Privacy Policy",
  "support.privacyOpenWeb": "Open Web Version",
  "support.privacyDeletePage": "Account Deletion Page",
  "support.privacyPublicNote":
    "Both pages are public at aeternainvicta.com/privacy and aeternainvicta.com/delete-account and work without the app. Privacy requests: {email}.",
  "support.monetization": "Monetization Information",
  "support.monetizationCopy":
    "How the game is developed, what advertisements and Currency are offered, and our no pay-to-win commitment.",
  "support.designPhilosophy": "Design Philosophy",
  "support.designPhilosophyCopy":
    "A short letter from the designer about the idea behind the game.",
  "support.designPhilosophyButton":
    "Learn More About the Idea Behind Aeterna Invicta",
  "support.credits": "Credits and Thank You",
  "support.creditsCopy":
    "Friends, playtesters, and the publisher who helped make this possible.",
  "support.entryTitle.about": "About Aeterna Invicta",
  "support.entryTitle.ageRating": "Age Rating and Content Advisory",
  "support.entryTitle.community": "Community Guidelines and Safety",
  "support.entryTitle.terms": "Terms of Use",
  "support.entryTitle.accountData": "Accounts and Data Deletion",
  "support.entrySummary.about":
    "What the game is, how it is played, and who makes it.",
  "support.entrySummary.ageRating":
    "Intended for players 13 and up. Contains fantasy violence and depictions of blood.",
  "support.entrySummary.community":
    "How to stay safe, what is not allowed, and how to report a problem.",
  "support.entrySummary.terms":
    "The rules for using the game, your account, and in-game items.",
  "support.entrySummary.accountData":
    "Guest play, registered accounts, and how to delete your account and data.",
  "support.contact.type": "Type",
  "support.contact.bug": "Bug Reporting",
  "support.contact.email": "Email (for a response)",
  "support.contact.bugPrompt":
    "Please describe what you were doing and what was happening when the bug occurred.",
  "support.contact.helpPrompt": "How can we help?",
  "support.contact.send": "Send",
  "support.contact.sentTitle": "Message Sent",
  "support.contact.enterEmail": "Enter a valid email address.",
  "support.contact.enterMessage": "Enter a message.",
  "support.contact.sendFailed": "Could not send. Try again.",
  "support.contact.confirmation":
    "To complete contact, send the prepared email to {email} from your email service provider.",
  "lore.readMore": "Read More",
  "rulebook.title": "Aeterna Invicta Rulebook",
  "rulebook.contents": "Contents",
  "rulebook.tableOfContents": "Table of Contents",
  "support.privacyLoadFailed": "Could not load Privacy Policy.",
  "social.reportSubmitted":
    "Report submitted. Thank you for helping keep Aeterna Invicta safe.",
  "social.reportFailed": "Could not submit report.",
  "social.playerFallback": "player",
  "social.partyInviteSent": "Party invite sent to {name}.",
  "social.challengeSent": "Challenge sent to {name}.",
  "social.challengeDeclined": "Challenge declined.",
  "social.challengeDeclinedBy": "{name} declined your challenge.",
  "account.createdSignInRequired": "Account created, but sign-in is required.",
  "account.createdPlayingAs": "Account created. Playing as {name}.",
  "library.collection": "Collection",
  "library.rulebook": "Rulebook",
  "library.glossary": "Glossary",
  "library.lore": "Lore",
  "library.intro":
    "Browse your collection and sample decks, look up keywords and mechanics, or read the lore of the realm.",
  "library.decksIntro":
    "Sample decks that can be viewed for inspiration or exported for use if you have the cards unlocked.",
  "library.missingCards": "Missing cards from your collection",
  "library.noDecks": "No library decks available.",
  "library.resetDecks": "Reset Decks",
  "library.resetDecksTitle": "Reset Decks?",
  "library.resetDecksBody":
    "This replaces all of your saved decks with the Library decks you own every card for. Custom decks and edits will be lost.",
  "library.export": "Export",
  "library.deckAbilityPower": "Ability · Power {power}",
  "glossary.backToSearch": "Back to Search",
  "glossary.relatedCards": "Related Cards ({n})",
  "glossary.noRelatedCards": "No related cards found.",
  "glossary.search": "Search",
  "glossary.searchPlaceholder": "Keywords, terms, mechanics",
  "glossary.noMatches": "No matching terms.",
  "patchNotes.title": "Patch Notes",
  "workshop.showControls": "Show Controls",
  "workshop.hideControls": "Hide Controls",
  "workshop.addCard": "Add Card",
  "workshop.yourTurn": "Your Turn",
  "workshop.opponentTurn": "Opponent Turn",
  "workshop.reset": "Reset",
  "workshop.hp": "HP {hp}/{maxHp}",
  "workshop.switchAspectFor": "Switch Aspect for {name}",
  "workshop.addCardTo": "Add card to {name}",
  "workshop.chooseAspect": "Choose an Aspect for this seat.",
  "workshop.maxCopiesPerSide": "Max {max} copies of the same card per side.",
  "gamepad.connected": "Controller connected",
  "gamepad.statusTitle": "{pad} · Select toggles navbar/view",
  "gamepad.ariaNav": "Controller connected, navbar selected",
  "gamepad.ariaView": "Controller connected, view selected",
  "gamepad.padNav": "Pad · Nav",
  "gamepad.padView": "Pad · View",
  "gamepad.connectedToast": "Controller connected: {label}",
  "card.statusEffect": "Status effect",
  "card.empoweredPhysicalArmor": "Empowered: Physical Armor +{amount} (Trait, while equipped)",
  "card.empoweredMagicArmor": "Empowered: Magic Armor +{amount} (Trait, while equipped)",
  "card.levels": "Levels",
  "card.level": "Level",
  "card.cost": "Cost",
  "card.tapToReturn": "Tap to return card",
  "card.powerN": "Power {power}",
  "card.locked": "Locked",
  "match.board.needResource": "Need {need} {attribute} (you have {have})",
  "match.board.needHealth": "Need {need} health (you have {have})",
};

export default en;
